

// import React, {
//   useEffect,
//   useState
// } from "react";

// import axios from "axios";

// import { API } from "../components/config";

// import "../style/ProfesorPlaneaciones.css";

// export default function ProfesorPlaneaciones() {

//   const token = localStorage.getItem("token");

//   const headers = {
//     Authorization: `Bearer ${token}`
//   };

//   /* ======================================================
//      STATES
//   ====================================================== */

//   const [planeaciones, setPlaneaciones] = useState([]);

//   const [loading, setLoading] = useState(false);

//   const [modoCrear, setModoCrear] = useState(false);

//   const [guardando, setGuardando] = useState({});
// const [timers, setTimers] = useState({});

//   const [
//     planeacionSeleccionada,
//     setPlaneacionSeleccionada
//   ] = useState(null);

//   const [unidades, setUnidades] = useState([]);

//   /* ======================================================
//      FILTRO PERIODOS
//   ====================================================== */

//   const [
//     filtroPeriodo,
//     setFiltroPeriodo
//   ] = useState("");

//   /* ======================================================
//      COMBOS
//   ====================================================== */

//   const [anios, setAnios] = useState([]);

//   const [periodos, setPeriodos] = useState([]);

//   const [grados, setGrados] = useState([]);

//   const [grupos, setGrupos] = useState([]);

//   const [areas, setAreas] = useState([]);

//   const [asignaturas, setAsignaturas] = useState([]);

//   /* ======================================================
//      FORM
//   ====================================================== */

//   const [form, setForm] = useState({

//     anio_lectivo_id: "",
//     periodo_id: "",

//     grado_id: "",
//     grupo_id: "",

//     area_id: "",
//     asignatura_id: "",

//     titulo: ""

//   });

//   /* ======================================================
//      CARGAR COMBOS
//   ====================================================== */

//   const cargarCombos = async () => {

//     try {

//       const [

//         aniosRes,
//         periodosRes,
//         gradosRes,
//         gruposRes,
//         areasRes,
//         asignaturasRes

//       ] = await Promise.all([

//         axios.get(
//           `${API}/planeaciones/anioslectivos`,
//           { headers }
//         ),

//         axios.get(
//           `${API}/planeaciones/periodos`,
//           { headers }
//         ),

//         axios.get(
//           `${API}/planeaciones/grados`,
//           { headers }
//         ),

//         axios.get(
//           `${API}/planeaciones/grupos`,
//           { headers }
//         ),

//         axios.get(
//           `${API}/planeaciones/areas`,
//           { headers }
//         ),

//         axios.get(
//           `${API}/planeaciones/asignaturas`,
//           { headers }
//         )

//       ]);

//       const listaPeriodos =
//         periodosRes.data.periodos || [];

//       setAnios(
//         aniosRes.data.anios || []
//       );

//       setPeriodos(listaPeriodos);

//       setGrados(
//         gradosRes.data.grados || []
//       );

//       setGrupos(
//         gruposRes.data.grupos || []
//       );

//       setAreas(
//         areasRes.data.areas || []
//       );

//       setAsignaturas(
//         asignaturasRes.data.asignaturas || []
//       );

//       /* =========================================
//          SELECCIONAR PERIODO ACTIVO
//       ========================================= */

//       const periodoActivo =
//         listaPeriodos.find(
//           (p) =>
//             p.activo === 1 ||
//             p.activo === true ||
//             p.estado === "ACTIVO"
//         );

//       if (periodoActivo) {

//         setFiltroPeriodo(
//           String(periodoActivo.id)
//         );

//         setForm((prev) => ({
//           ...prev,
//           periodo_id:
//           String(periodoActivo.id)
//         }));

//       } else {

//         setFiltroPeriodo("TODOS");

//       }

//     } catch (error) {

//       console.error(
//         "ERROR CARGANDO COMBOS",
//         error
//       );

//     }

//   };

//   /* ======================================================
//      LISTAR PLANEACIONES
//   ====================================================== */

//   const listarPlaneaciones = async () => {

//     try {

//       setLoading(true);

//       const res = await axios.get(
//         `${API}/planeaciones`,
//         { headers }
//       );

//       let lista =
//         res.data.planeaciones || [];

//       console.log(
//         "PLANEACIONES BACKEND:",
//         lista
//       );

//       /* =========================================
//          FILTRAR POR PERIODO
//       ========================================= */

//       if (
//         filtroPeriodo &&
//         filtroPeriodo !== "TODOS"
//       ) {

//         lista = lista.filter(
//           (p) =>
//             String(p.periodo_id) ===
//             String(filtroPeriodo)
//         );

//       }

//       setPlaneaciones(lista);

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error cargando planeaciones"
//       );

//     } finally {

//       setLoading(false);

//     }

//   };

//   /* ======================================================
//      CREAR
//   ====================================================== */

//   const crearPlaneacion = async () => {

//     try {

//       if (

//         !form.anio_lectivo_id ||
//         !form.periodo_id ||
//         !form.grado_id ||
//         !form.grupo_id ||
//         !form.area_id ||
//         !form.asignatura_id ||
//         !form.titulo

//       ) {

//         return alert(
//           "Complete todos los campos"
//         );

//       }

//       const res = await axios.post(

//         `${API}/planeaciones`,

//         form,

//         { headers }

//       );

//       alert(
//         "Planeación creada correctamente"
//       );

//       setModoCrear(false);

//       listarPlaneaciones();

//       obtenerPlaneacion(
//         res.data.planeacion_id
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error creando planeación"
//       );

//     }

//   };

//   /* ======================================================
//      DETALLE
//   ====================================================== */

//   // const obtenerPlaneacion = async (id) => {

//   //   try {

//   //     const res = await axios.get(
//   //       `${API}/planeaciones/${id}`,
//   //       { headers }
//   //     );

//   //     setPlaneacionSeleccionada(
//   //       res.data.planeacion
//   //     );

//   //     setUnidades(
//   //       res.data.unidades || []
//   //     );

//   //   } catch (error) {

//   //     console.error(error);

//   //     alert(
//   //       "Error obteniendo planeación"
//   //     );

//   //   }

//   // };

//   /* ======================================================
//    OBTENER PLANEACIÓN
// ====================================================== */

// const obtenerPlaneacion = async (id) => {

//   if (!id) {
//     console.warn("⚠️ No se recibió el ID de la planeación.");
//     return;
//   }

//   try {

//     console.log("📥 Consultando planeación:", id);

//     const res = await axios.get(
//       `${API}/planeaciones/${id}`,
//       { headers }
//     );

//     console.log("✅ RESPUESTA COMPLETA:", res.data);

//     if (!res.data) {
//       throw new Error("La respuesta del servidor está vacía.");
//     }

//     const planeacion = res.data.planeacion || null;
//     const unidades = Array.isArray(res.data.unidades)
//       ? res.data.unidades
//       : [];

//     console.log("📄 Planeación:", planeacion);
//     console.log("📚 Unidades:", unidades);

//     if (!planeacion) {
//       alert("La planeación no fue encontrada.");
//       setPlaneacionSeleccionada(null);
//       setUnidades([]);
//       return;
//     }

//     setPlaneacionSeleccionada(planeacion);
//     setUnidades(unidades);

//   } catch (error) {

//     console.error("❌ Error obteniendo planeación:", error);

//     if (error.response) {

//       console.error("Status:", error.response.status);
//       console.error("Data:", error.response.data);

//     }

//     setPlaneacionSeleccionada(null);
//     setUnidades([]);

//     alert(
//       error.response?.data?.message ||
//       "Error obteniendo la planeación."
//     );

//   }

// };

//   /* ======================================================
//      AGREGAR UNIDAD
//   ====================================================== */

//   const agregarUnidad = async () => {

//     try {

//       await axios.post(

//         `${API}/planeaciones/${planeacionSeleccionada.id}/unidades`,

//         {

//           unidad:
//           `Unidad ${unidades.length + 1}`,

//           semana_inicio: "",
//           semana_fin: "",

//           tema: "",
//           competencia: "",
//           dba: "",
//           estandares: "",
//           desempenos: "",

//           metodologia: "",
//           actividades: "",
//           recursos: "",
//           evidencias: "",
//           evaluacion: "",

//           piar: "",
//           observaciones: "",

//           orden:
//           unidades.length + 1

//         },

//         { headers }

//       );

//       obtenerPlaneacion(
//         planeacionSeleccionada.id
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error agregando unidad"
//       );

//     }

//   };

//   /* ======================================================
//      ACTUALIZAR UNIDAD
//   ====================================================== */

//   // const actualizarUnidad = async (
//   //   unidadId,
//   //   campo,
//   //   valor
//   // ) => {

//   //   try {

//   //     await axios.put(

//   //       `${API}/planeaciones/unidades/${unidadId}`,

//   //       {
//   //         [campo]: valor
//   //       },

//   //       { headers }

//   //     );

//   //   } catch (error) {

//   //     console.error(error);

//   //   }

//   // };


//   const actualizarUnidad = (
//     unidadId,
//     campo,
//     valor
// ) => {

//     // Marca como guardando
//     setGuardando(prev => ({
//         ...prev,
//         [`${unidadId}_${campo}`]: true
//     }));

//     // Cancela el timer anterior
//     if (timers[`${unidadId}_${campo}`]) {
//         clearTimeout(
//             timers[`${unidadId}_${campo}`]
//         );
//     }

//     // Espera 800ms antes de guardar
//     const nuevoTimer = setTimeout(async () => {

//         try {

//             await axios.put(

//                 `${API}/planeaciones/unidades/${unidadId}`,

//                 {
//                     [campo]: valor
//                 },

//                 { headers }

//             );

//         } catch (error) {

//             console.error(error);

//         } finally {

//             setGuardando(prev => ({
//                 ...prev,
//                 [`${unidadId}_${campo}`]: false
//             }));

//         }

//     }, 800);

//     setTimers(prev => ({
//         ...prev,
//         [`${unidadId}_${campo}`]: nuevoTimer
//     }));

// };
//   /* ======================================================
//      ELIMINAR UNIDAD
//   ====================================================== */

//   const eliminarUnidad = async (id) => {

//     try {

//       const ok = window.confirm(
//         "¿Eliminar unidad?"
//       );

//       if (!ok) return;

//       await axios.delete(

//         `${API}/planeaciones/unidades/${id}`,

//         { headers }

//       );

//       obtenerPlaneacion(
//         planeacionSeleccionada.id
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error eliminando unidad"
//       );

//     }

//   };

//   /* ======================================================
//      ENVIAR
//   ====================================================== */

//   const enviarPlaneacion = async () => {

//     try {

//       await axios.post(

//         `${API}/planeaciones/${planeacionSeleccionada.id}/enviar`,

//         {},

//         { headers }

//       );

//       alert(
//         "Planeación enviada"
//       );

//       listarPlaneaciones();

//       obtenerPlaneacion(
//         planeacionSeleccionada.id
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error enviando planeación"
//       );

//     }

//   };

//   /* ======================================================
//      DESCARGAR PDF
//   ====================================================== */

//   const descargarPDF = async (id) => {

//     try {

//       const response = await axios.get(
//         `${API}/planeaciones/${id}/pdf`,
//         {
//           headers,
//           responseType: "blob"
//         }
//       );

//       const url = window.URL.createObjectURL(
//         new Blob([response.data])
//       );

//       const link =
//         document.createElement("a");

//       link.href = url;

//       link.setAttribute(
//         "download",
//         `planeacion_${id}.pdf`
//       );

//       document.body.appendChild(link);

//       link.click();

//       link.remove();

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error descargando PDF"
//       );

//     }

//   };

//   /* ======================================================
//      EFFECT
//   ====================================================== */

//   useEffect(() => {

//     cargarCombos();

//   }, []);

//   useEffect(() => {

//     if (
//       filtroPeriodo !== ""
//     ) {

//       listarPlaneaciones();

//     }

//   }, [filtroPeriodo]);

//   return (

//     <div className="planeaciones-container">

//       {/* =========================================
//           SIDEBAR
//       ========================================= */}

//       <div className="planeaciones-sidebar">

//         <div className="sidebar-header">

//           <h2>
//             Planeaciones
//           </h2>

//           <button
//             className="btn-crear"
//             onClick={() =>
//               setModoCrear(true)
//             }
//           >
//             + Nueva
//           </button>

//         </div>

//         {/* =====================================
//             FILTRO PERIODOS
//         ===================================== */}

//         <div className="filtro-periodo">

//           <select
//             value={filtroPeriodo}
//             onChange={(e) =>
//               setFiltroPeriodo(
//                 e.target.value
//               )
//             }
//           >

//             <option value="TODOS">
//               Todos los periodos
//             </option>

//             {

//               periodos.map((p) => (

//                 <option
//                   key={p.id}
//                   value={String(p.id)}
//                 >
//                   {p.nombre}
//                 </option>

//               ))

//             }

//           </select>

//         </div>

//         {

//           loading

//           ? (
//             <p>Cargando...</p>
//           )

//           : (

//             planeaciones.map((p) => (

//               <div
//                 key={p.id}
//                 className={`card-planeacion ${
//                   planeacionSeleccionada?.id === p.id
//                   ? "active"
//                   : ""
//                 }`}
//                 onClick={() =>
//                   obtenerPlaneacion(p.id)
//                 }
//               >

//                 <h4>
//                   {p.titulo}
//                 </h4>

//                 <p>
//                   <strong>
//                     Materia:
//                   </strong>
//                   {" "}
//                   {p.asignatura}
//                 </p>

//                 <p>
//                   <strong>
//                     Grado:
//                   </strong>
//                   {" "}
//                   {p.grado}
//                 </p>

//                 <p>
//                   <strong>
//                     Grupo:
//                   </strong>
//                   {" "}
//                   {p.grupo}
//                 </p>

//                 <p>
//                   <strong>
//                     Periodo:
//                   </strong>
//                   {" "}
//                   {p.periodo}
//                 </p>

//                 <span>
//                   Estado:
//                   {" "}
//                   {p.estado}
//                 </span>

//               </div>

//             ))

//           )

//         }

//       </div>

//       {/* =========================================
//           CONTENT
//       ========================================= */}

//       <div className="planeaciones-content">

//         {/* =====================================
//             CREAR
//         ===================================== */}

//         {

//           modoCrear && (

//             <div className="crear-planeacion">

//               <h2>
//                 Nueva Planeación
//               </h2>

//               <div className="grid-form">

//                 {/* AÑO */}

//                 <select
//                   value={form.anio_lectivo_id}
//                   onChange={(e) =>
//                     setForm({
//                       ...form,
//                       anio_lectivo_id:
//                       e.target.value
//                     })
//                   }
//                 >

//                   <option value="">
//                     Seleccione año lectivo
//                   </option>

//                   {

//                     anios.map((a) => (

//                       <option
//                         key={a.id}
//                         value={a.id}
//                       >
//                         {a.nombre}
//                       </option>

//                     ))

//                   }

//                 </select>

//                 {/* PERIODO */}

//                 <select
//                   value={form.periodo_id}
//                   onChange={(e) =>
//                     setForm({
//                       ...form,
//                       periodo_id:
//                       e.target.value
//                     })
//                   }
//                 >

//                   <option value="">
//                     Seleccione periodo
//                   </option>

//                   {

//                     periodos.map((p) => (

//                       <option
//                         key={p.id}
//                         value={p.id}
//                       >
//                         {p.nombre}
//                       </option>

//                     ))

//                   }

//                 </select>

//                 {/* GRADO */}

//                <select
//     value={form.grado_id}
//     onChange={(e) =>
//         setForm({
//             ...form,
//             grado_id: Number(e.target.value)
//         })
//     }
// >

//     <option value="">
//         Seleccione grado
//     </option>

//     {

//         grados.map((g) => (

//             <option
//                 key={g.id}
//                 value={g.id}
//             >
//                 {g.nombre}
//             </option>

//         ))

//     }

// </select>

//                 {/* GRUPO */}

//                 {/* <select
//                   value={form.grupo_id}
//                   onChange={(e) =>
//                     setForm({
//                       ...form,
//                       grupo_id:
//                       e.target.value
//                     })
//                   }
//                 >

//                   <option value="">
//                     Seleccione grupo
//                   </option>

//                   {

//                     grupos.map((g) => (

//                       <option
//                         key={g.id}
//                         value={g.nombre}
//                       >
//                         {g.nombre}
//                       </option>

//                     ))

//                   }

//                 </select> */}
// <select
//     value={form.grupo_id}
//     onChange={(e) =>
//         setForm({
//             ...form,
//             grupo_id: Number(e.target.value)
//         })
//     }
// >

//     <option value="">
//         Seleccione grupo
//     </option>

//     {

//         grupos.map((g) => (

//             <option
//                 key={g.id}
//                 value={g.id}
//             >
//                 {g.nombre}
//             </option>

//         ))

//     }

// </select>

//                 {/* AREA */}

//                 <select
//                   value={form.area_id}
//                   onChange={(e) =>
//                     setForm({
//                       ...form,
//                       area_id:
//                       e.target.value
//                     })
//                   }
//                 >

//                   <option value="">
//                     Seleccione área
//                   </option>

//                   {

//                     areas.map((a) => (

//                       <option
//                         key={a.id}
//                         value={a.id}
//                       >
//                         {a.nombre}
//                       </option>

//                     ))

//                   }

//                 </select>

//                 {/* ASIGNATURA */}

//                 <select
//                   value={form.asignatura_id}
//                   onChange={(e) =>
//                     setForm({
//                       ...form,
//                       asignatura_id:
//                       e.target.value
//                     })
//                   }
//                 >

//                   <option value="">
//                     Seleccione asignatura
//                   </option>

//                   {

//                     asignaturas.map((a) => (

//                       <option
//                         key={a.id}
//                         value={a.id}
//                       >
//                         {a.nombre}
//                       </option>

//                     ))

//                   }

//                 </select>

//               </div>

//               <input
//                 className="titulo-input"
//                 placeholder="Título planeación"
//                 value={form.titulo}
//                 onChange={(e) =>
//                   setForm({
//                     ...form,
//                     titulo:
//                     e.target.value
//                   })
//                 }
//               />

//               <div className="acciones-crear">

//                 <button
//                   className="btn-guardar"
//                   onClick={crearPlaneacion}
//                 >
//                   Guardar
//                 </button>

//                 <button
//                   className="btn-cancelar"
//                   onClick={() =>
//                     setModoCrear(false)
//                   }
//                 >
//                   Cancelar
//                 </button>

//               </div>

//             </div>

//           )

//         }

//         {/* =====================================
//             DETALLE
//         ===================================== */}

//         {

//           planeacionSeleccionada && (

//             <div className="detalle-planeacion">

//               <div className="detalle-header">

//                 <div>

//                   <h1>
//                     {
//                       planeacionSeleccionada.titulo
//                     }
//                   </h1>

//                   <div className="detalle-info-top">

//                     <p>
//                       <strong>
//                         Materia:
//                       </strong>
//                       {" "}
//                       {
//                         planeacionSeleccionada.asignatura
//                       }
//                     </p>

//                     <p>
//                       <strong>
//                         Grado:
//                       </strong>
//                       {" "}
//                       {
//                         planeacionSeleccionada.grado
//                       }
//                     </p>

//                     <p>
//                       <strong>
//                         Grupo:
//                       </strong>
//                       {" "}
//                       {
//                         planeacionSeleccionada.grupo
//                       }
//                     </p>

//                     <p>
//                       <strong>
//                         Periodo:
//                       </strong>
//                       {" "}
//                       {
//                         planeacionSeleccionada.periodo
//                       }
//                     </p>

//                     <p>
//                       <strong>
//                         Estado:
//                       </strong>
//                       {" "}
//                       {
//                         planeacionSeleccionada.estado
//                       }
//                     </p>

//                   </div>

//                 </div>

//                 <div className="acciones-header">

//                   <button
//                     className="btn-agregar"
//                     onClick={agregarUnidad}
//                   >
//                     + Unidad
//                   </button>

//                   <button
//                     className="btn-pdf"
//                     onClick={() =>
//                       descargarPDF(
//                         planeacionSeleccionada.id
//                       )
//                     }
//                   >
//                     Descargar PDF
//                   </button>

//                   {

//                     planeacionSeleccionada.estado !==
//                     "ENVIADA" && (

//                       <button
//                         className="btn-enviar"
//                         onClick={
//                           enviarPlaneacion
//                         }
//                       >
//                         Enviar
//                       </button>

//                     )

//                   }

//                 </div>

//               </div>

//               {

//                 unidades.map((u) => (

//                   <div
//                     key={u.id}
//                     className="unidad-card"
//                   >

//                     <div className="unidad-top">

//                       <h3>
//                         {u.unidad}
//                       </h3>

//                       <button
//                         className="btn-delete"
//                         onClick={() =>
//                           eliminarUnidad(u.id)
//                         }
//                       >
//                         Eliminar
//                       </button>

//                     </div>

//                     <div className="grid-unidad">

//                    <textarea
//     placeholder="Tema"
//     defaultValue={u.tema}
//     onChange={(e)=>
//         actualizarUnidad(
//             u.id,
//             "tema",
//             e.target.value
//         )
//     }
// />

// {
// guardando[`${u.id}_tema`] &&
// <div className="guardando">
//     Guardando...
// </div>
// }

//                       <textarea
//                         placeholder="Competencia"
//                         defaultValue={u.competencia}
//                         onBlur={(e) =>
//                           actualizarUnidad(
//                             u.id,
//                             "competencia",
//                             e.target.value
//                           )
//                         }
//                       />

//                       <textarea
//                         placeholder="DBA"
//                         defaultValue={u.dba}
//                         onBlur={(e) =>
//                           actualizarUnidad(
//                             u.id,
//                             "dba",
//                             e.target.value
//                           )
//                         }
//                       />

//                       <textarea
//                         placeholder="Estándares"
//                         defaultValue={u.estandares}
//                         onBlur={(e) =>
//                           actualizarUnidad(
//                             u.id,
//                             "estandares",
//                             e.target.value
//                           )
//                         }
//                       />

//                       <textarea
//                         placeholder="Desempeños"
//                         defaultValue={u.desempenos}
//                         onBlur={(e) =>
//                           actualizarUnidad(
//                             u.id,
//                             "desempenos",
//                             e.target.value
//                           )
//                         }
//                       />

//                       <textarea
//                         placeholder="Metodología"
//                         defaultValue={u.metodologia}
//                         onBlur={(e) =>
//                           actualizarUnidad(
//                             u.id,
//                             "metodologia",
//                             e.target.value
//                           )
//                         }
//                       />

//                       <textarea
//                         placeholder="Actividades"
//                         defaultValue={u.actividades}
//                         onBlur={(e) =>
//                           actualizarUnidad(
//                             u.id,
//                             "actividades",
//                             e.target.value
//                           )
//                         }
//                       />

//                       <textarea
//                         placeholder="Recursos"
//                         defaultValue={u.recursos}
//                         onBlur={(e) =>
//                           actualizarUnidad(
//                             u.id,
//                             "recursos",
//                             e.target.value
//                           )
//                         }
//                       />

//                       <textarea
//                         placeholder="Evidencias"
//                         defaultValue={u.evidencias}
//                         onBlur={(e) =>
//                           actualizarUnidad(
//                             u.id,
//                             "evidencias",
//                             e.target.value
//                           )
//                         }
//                       />

//                       <textarea
//                         placeholder="Evaluación"
//                         defaultValue={u.evaluacion}
//                         onBlur={(e) =>
//                           actualizarUnidad(
//                             u.id,
//                             "evaluacion",
//                             e.target.value
//                           )
//                         }
//                       />

//                       <textarea
//                         placeholder="PIAR"
//                         defaultValue={u.piar}
//                         onBlur={(e) =>
//                           actualizarUnidad(
//                             u.id,
//                             "piar",
//                             e.target.value
//                           )
//                         }
//                       />

//                       <textarea
//                         placeholder="Observaciones"
//                         defaultValue={u.observaciones}
//                         onBlur={(e) =>
//                           actualizarUnidad(
//                             u.id,
//                             "observaciones",
//                             e.target.value
//                           )
//                         }
//                       />

//                     </div>

//                   </div>

//                 ))

//               }

//             </div>

//           )

//         }

//       </div>

//     </div>

//   );

// }


import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import { API } from "../components/config";

import "../style/ProfesorPlaneaciones.css";

export default function ProfesorPlaneaciones() {

  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`
  };

  /* ======================================================
     STATES
  ====================================================== */

  const [planeaciones, setPlaneaciones] = useState([]);

  const [loading, setLoading] = useState(false);

  const [modoCrear, setModoCrear] = useState(false);

  const [
    planeacionSeleccionada,
    setPlaneacionSeleccionada
  ] = useState(null);

  const [unidades, setUnidades] = useState([]);

  // 🔧 NUEVO: borrador editable por unidad (id -> campos)
  const [borradores, setBorradores] = useState({});

  // 🔧 NUEVO: estado de guardado por unidad (id -> 'idle'|'guardando'|'ok'|'error')
  const [estadoGuardado, setEstadoGuardado] = useState({});

  /* ======================================================
     FILTRO PERIODOS
  ====================================================== */

  const [
    filtroPeriodo,
    setFiltroPeriodo
  ] = useState("");

  /* ======================================================
     COMBOS
  ====================================================== */

  const [anios, setAnios] = useState([]);

  const [periodos, setPeriodos] = useState([]);

  const [grados, setGrados] = useState([]);

  const [grupos, setGrupos] = useState([]);

  const [areas, setAreas] = useState([]);

  const [asignaturas, setAsignaturas] = useState([]);

  /* ======================================================
     FORM
  ====================================================== */

  const [form, setForm] = useState({

    anio_lectivo_id: "",
    periodo_id: "",

    grado_id: "",
    grupo_id: "",

    area_id: "",
    asignatura_id: "",

    titulo: ""

  });

  const CAMPOS_UNIDAD = [
    ["tema", "Tema"],
    ["competencia", "Competencia"],
    ["dba", "DBA"],
    ["estandares", "Estándares"],
    ["desempenos", "Desempeños"],
    ["metodologia", "Metodología"],
    ["actividades", "Actividades"],
    ["recursos", "Recursos"],
    ["evidencias", "Evidencias"],
    ["evaluacion", "Evaluación"],
    ["piar", "PIAR"],
    ["observaciones", "Observaciones"]
  ];

  /* ======================================================
     CARGAR COMBOS
  ====================================================== */

  const cargarCombos = async () => {

    try {

      const [

        aniosRes,
        periodosRes,
        gradosRes,
        gruposRes,
        areasRes,
        asignaturasRes

      ] = await Promise.all([

        axios.get(
          `${API}/planeaciones/anioslectivos`,
          { headers }
        ),

        axios.get(
          `${API}/planeaciones/periodos`,
          { headers }
        ),

        axios.get(
          `${API}/planeaciones/grados`,
          { headers }
        ),

        axios.get(
          `${API}/planeaciones/grupos`,
          { headers }
        ),

        axios.get(
          `${API}/planeaciones/areas`,
          { headers }
        ),

        axios.get(
          `${API}/planeaciones/asignaturas`,
          { headers }
        )

      ]);

      const listaPeriodos =
        periodosRes.data.periodos || [];

      setAnios(
        aniosRes.data.anios || []
      );

      setPeriodos(listaPeriodos);

      setGrados(
        gradosRes.data.grados || []
      );

      setGrupos(
        gruposRes.data.grupos || []
      );

      setAreas(
        areasRes.data.areas || []
      );

      setAsignaturas(
        asignaturasRes.data.asignaturas || []
      );

      /* =========================================
         SELECCIONAR PERIODO ACTIVO
      ========================================= */

      const periodoActivo =
        listaPeriodos.find(
          (p) =>
            p.activo === 1 ||
            p.activo === true ||
            p.estado === "ACTIVO"
        );

      if (periodoActivo) {

        setFiltroPeriodo(
          String(periodoActivo.id)
        );

        setForm((prev) => ({
          ...prev,
          periodo_id:
          String(periodoActivo.id)
        }));

      } else {

        setFiltroPeriodo("TODOS");

      }

    } catch (error) {

      console.error(
        "ERROR CARGANDO COMBOS",
        error
      );

    }

  };

  /* ======================================================
     LISTAR PLANEACIONES
  ====================================================== */

  const listarPlaneaciones = async () => {

    try {

      setLoading(true);

      const res = await axios.get(
        `${API}/planeaciones`,
        { headers }
      );

      let lista =
        res.data.planeaciones || [];

      if (
        filtroPeriodo &&
        filtroPeriodo !== "TODOS"
      ) {

        lista = lista.filter(
          (p) =>
            String(p.periodo_id) ===
            String(filtroPeriodo)
        );

      }

      setPlaneaciones(lista);

    } catch (error) {

      console.error(error);

      alert(
        "Error cargando planeaciones"
      );

    } finally {

      setLoading(false);

    }

  };

  /* ======================================================
     CREAR
  ====================================================== */

  const crearPlaneacion = async () => {

    try {

      if (

        !form.anio_lectivo_id ||
        !form.periodo_id ||
        !form.grado_id ||
        !form.grupo_id ||
        !form.area_id ||
        !form.asignatura_id ||
        !form.titulo

      ) {

        return alert(
          "Complete todos los campos"
        );

      }

      const res = await axios.post(

        `${API}/planeaciones`,

        form,

        { headers }

      );

      alert(
        "Planeación creada correctamente"
      );

      setModoCrear(false);

      listarPlaneaciones();

      obtenerPlaneacion(
        res.data.planeacion_id
      );

    } catch (error) {

      console.error(error);

      alert(
        "Error creando planeación"
      );

    }

  };

  /* ======================================================
     OBTENER PLANEACIÓN
  ====================================================== */

  const obtenerPlaneacion = async (id) => {

    if (!id) {
      console.warn("⚠️ No se recibió el ID de la planeación.");
      return;
    }

    try {

      const res = await axios.get(
        `${API}/planeaciones/${id}`,
        { headers }
      );

      if (!res.data) {
        throw new Error("La respuesta del servidor está vacía.");
      }

      const planeacion = res.data.planeacion || null;
      const unidadesData = Array.isArray(res.data.unidades)
        ? res.data.unidades
        : [];

      if (!planeacion) {
        alert("La planeación no fue encontrada.");
        setPlaneacionSeleccionada(null);
        setUnidades([]);
        return;
      }

      setPlaneacionSeleccionada(planeacion);
      setUnidades(unidadesData);

      // 🔧 NUEVO: inicializar borradores con lo que viene de la BD
      const nuevosBorradores = {};

      unidadesData.forEach((u) => {
        nuevosBorradores[u.id] = {
          tema: u.tema || "",
          competencia: u.competencia || "",
          dba: u.dba || "",
          estandares: u.estandares || "",
          desempenos: u.desempenos || "",
          metodologia: u.metodologia || "",
          actividades: u.actividades || "",
          recursos: u.recursos || "",
          evidencias: u.evidencias || "",
          evaluacion: u.evaluacion || "",
          piar: u.piar || "",
          observaciones: u.observaciones || ""
        };
      });

      setBorradores(nuevosBorradores);

    } catch (error) {

      console.error("❌ Error obteniendo planeación:", error);

      setPlaneacionSeleccionada(null);
      setUnidades([]);

      alert(
        error.response?.data?.message ||
        "Error obteniendo la planeación."
      );

    }

  };

  /* ======================================================
     AGREGAR UNIDAD
  ====================================================== */

  const agregarUnidad = async () => {

    try {

      await axios.post(

        `${API}/planeaciones/${planeacionSeleccionada.id}/unidades`,

        {

          unidad:
          `Unidad ${unidades.length + 1}`,

          semana_inicio: "",
          semana_fin: "",

          tema: "",
          competencia: "",
          dba: "",
          estandares: "",
          desempenos: "",

          metodologia: "",
          actividades: "",
          recursos: "",
          evidencias: "",
          evaluacion: "",

          piar: "",
          observaciones: "",

          orden:
          unidades.length + 1

        },

        { headers }

      );

      obtenerPlaneacion(
        planeacionSeleccionada.id
      );

    } catch (error) {

      console.error(error);

      alert(
        "Error agregando unidad"
      );

    }

  };

  /* ======================================================
     🔧 NUEVO: EDITAR CAMPO EN BORRADOR (solo memoria local)
  ====================================================== */

  const editarCampoBorrador = (
    unidadId,
    campo,
    valor
  ) => {

    setBorradores((prev) => ({
      ...prev,
      [unidadId]: {
        ...prev[unidadId],
        [campo]: valor
      }
    }));

  };

  /* ======================================================
     🔧 NUEVO: GUARDAR UNIDAD COMPLETA (botón explícito)
  ====================================================== */

  const guardarUnidad = async (unidadId) => {

    const datos = borradores[unidadId];

    if (!datos) return;

    setEstadoGuardado((prev) => ({
      ...prev,
      [unidadId]: "guardando"
    }));

    try {

      await axios.put(

        `${API}/planeaciones/unidades/${unidadId}`,

        datos,

        { headers }

      );

      setEstadoGuardado((prev) => ({
        ...prev,
        [unidadId]: "ok"
      }));

      // Actualiza también la copia en "unidades" para que
      // quede sincronizada por si se recarga la vista
      setUnidades((prev) =>
        prev.map((u) =>
          u.id === unidadId
            ? { ...u, ...datos }
            : u
        )
      );

      // Oculta el "Guardado ✅" después de un momento
      setTimeout(() => {
        setEstadoGuardado((prev) => ({
          ...prev,
          [unidadId]: "idle"
        }));
      }, 2000);

    } catch (error) {

      console.error(
        "❌ Error guardando unidad:",
        error
      );

      setEstadoGuardado((prev) => ({
        ...prev,
        [unidadId]: "error"
      }));

      alert(
        error.response?.data?.msg ||
        error.response?.data?.message ||
        "Error guardando la unidad"
      );

    }

  };

  /* ======================================================
     ELIMINAR UNIDAD
  ====================================================== */

  const eliminarUnidad = async (id) => {

    try {

      const ok = window.confirm(
        "¿Eliminar unidad?"
      );

      if (!ok) return;

      await axios.delete(

        `${API}/planeaciones/unidades/${id}`,

        { headers }

      );

      obtenerPlaneacion(
        planeacionSeleccionada.id
      );

    } catch (error) {

      console.error(error);

      alert(
        "Error eliminando unidad"
      );

    }

  };

  /* ======================================================
     ENVIAR
  ====================================================== */

  const enviarPlaneacion = async () => {

    try {

      await axios.post(

        `${API}/planeaciones/${planeacionSeleccionada.id}/enviar`,

        {},

        { headers }

      );

      alert(
        "Planeación enviada"
      );

      listarPlaneaciones();

      obtenerPlaneacion(
        planeacionSeleccionada.id
      );

    } catch (error) {

      console.error(error);

      alert(
        "Error enviando planeación"
      );

    }

  };

  /* ======================================================
     DESCARGAR PDF
  ====================================================== */

  const descargarPDF = async (id) => {

    try {

      const response = await axios.get(
        `${API}/planeaciones/${id}/pdf`,
        {
          headers,
          responseType: "blob"
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data])
      );

      const link =
        document.createElement("a");

      link.href = url;

      link.setAttribute(
        "download",
        `planeacion_${id}.pdf`
      );

      document.body.appendChild(link);

      link.click();

      link.remove();

    } catch (error) {

      console.error(error);

      alert(
        "Error descargando PDF"
      );

    }

  };

  /* ======================================================
     EFFECT
  ====================================================== */

  useEffect(() => {

    cargarCombos();

  }, []);

  useEffect(() => {

    if (
      filtroPeriodo !== ""
    ) {

      listarPlaneaciones();

    }

  }, [filtroPeriodo]);

  return (

    <div className="planeaciones-container">

      {/* =========================================
          SIDEBAR
      ========================================= */}

      <div className="planeaciones-sidebar">

        <div className="sidebar-header">

          <h2>
            Planeaciones
          </h2>

          <button
            className="btn-crear"
            onClick={() =>
              setModoCrear(true)
            }
          >
            + Nueva
          </button>

        </div>

        <div className="filtro-periodo">

          <select
            value={filtroPeriodo}
            onChange={(e) =>
              setFiltroPeriodo(
                e.target.value
              )
            }
          >

            <option value="TODOS">
              Todos los periodos
            </option>

            {

              periodos.map((p) => (

                <option
                  key={p.id}
                  value={String(p.id)}
                >
                  {p.nombre}
                </option>

              ))

            }

          </select>

        </div>

        {

          loading

          ? (
            <p>Cargando...</p>
          )

          : (

            planeaciones.map((p) => (

              <div
                key={p.id}
                className={`card-planeacion ${
                  planeacionSeleccionada?.id === p.id
                  ? "active"
                  : ""
                }`}
                onClick={() =>
                  obtenerPlaneacion(p.id)
                }
              >

                <h4>
                  {p.titulo}
                </h4>

                <p>
                  <strong>
                    Materia:
                  </strong>
                  {" "}
                  {p.asignatura}
                </p>

                <p>
                  <strong>
                    Grado:
                  </strong>
                  {" "}
                  {p.grado}
                </p>

                <p>
                  <strong>
                    Grupo:
                  </strong>
                  {" "}
                  {p.grupo}
                </p>

                <p>
                  <strong>
                    Periodo:
                  </strong>
                  {" "}
                  {p.periodo}
                </p>

                <span>
                  Estado:
                  {" "}
                  {p.estado}
                </span>

              </div>

            ))

          )

        }

      </div>

      {/* =========================================
          CONTENT
      ========================================= */}

      <div className="planeaciones-content">

        {

          modoCrear && (

            <div className="crear-planeacion">

              <h2>
                Nueva Planeación
              </h2>

              <div className="grid-form">

                <select
                  value={form.anio_lectivo_id}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      anio_lectivo_id:
                      e.target.value
                    })
                  }
                >

                  <option value="">
                    Seleccione año lectivo
                  </option>

                  {

                    anios.map((a) => (

                      <option
                        key={a.id}
                        value={a.id}
                      >
                        {a.nombre}
                      </option>

                    ))

                  }

                </select>

                <select
                  value={form.periodo_id}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      periodo_id:
                      e.target.value
                    })
                  }
                >

                  <option value="">
                    Seleccione periodo
                  </option>

                  {

                    periodos.map((p) => (

                      <option
                        key={p.id}
                        value={p.id}
                      >
                        {p.nombre}
                      </option>

                    ))

                  }

                </select>

               <select
                    value={form.grado_id}
            onChange={(e) =>
    setForm({
        ...form,
        grado_id: e.target.value
    })
}
                >

                    <option value="">
                        Seleccione grado
                    </option>

                    {

                        grados.map((g) => (

                            <option
                                key={g.id}
                                value={g.id}
                            >
                                {g.nombre}
                            </option>

                        ))

                    }

                </select>

                <select
                    value={form.grupo_id}
            onChange={(e) =>
    setForm({
        ...form,
        grupo_id: e.target.value
    })
}
                >

                    <option value="">
                        Seleccione grupo
                    </option>

                    {

                        grupos.map((g) => (

                            <option
                                key={g.id}
                                value={g.id}
                            >
                                {g.nombre}
                            </option>

                        ))

                    }

                </select>

                <select
                  value={form.area_id}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      area_id:
                      e.target.value
                    })
                  }
                >

                  <option value="">
                    Seleccione área
                  </option>

                  {

                    areas.map((a) => (

                      <option
                        key={a.id}
                        value={a.id}
                      >
                        {a.nombre}
                      </option>

                    ))

                  }

                </select>

                <select
                  value={form.asignatura_id}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      asignatura_id:
                      e.target.value
                    })
                  }
                >

                  <option value="">
                    Seleccione asignatura
                  </option>

                  {

                    asignaturas.map((a) => (

                      <option
                        key={a.id}
                        value={a.id}
                      >
                        {a.nombre}
                      </option>

                    ))

                  }

                </select>

              </div>

              <input
                className="titulo-input"
                placeholder="Título planeación"
                value={form.titulo}
                onChange={(e) =>
                  setForm({
                    ...form,
                    titulo:
                    e.target.value
                  })
                }
              />

              <div className="acciones-crear">

                <button
                  className="btn-guardar"
                  onClick={crearPlaneacion}
                >
                  Guardar
                </button>

                <button
                  className="btn-cancelar"
                  onClick={() =>
                    setModoCrear(false)
                  }
                >
                  Cancelar
                </button>

              </div>

            </div>

          )

        }

        {

          planeacionSeleccionada && (

            <div className="detalle-planeacion">

              <div className="detalle-header">

                <div>

                  <h1>
                    {
                      planeacionSeleccionada.titulo
                    }
                  </h1>

                  <div className="detalle-info-top">

                    <p>
                      <strong>
                        Materia:
                      </strong>
                      {" "}
                      {
                        planeacionSeleccionada.asignatura
                      }
                    </p>

                    <p>
                      <strong>
                        Grado:
                      </strong>
                      {" "}
                      {
                        planeacionSeleccionada.grado
                      }
                    </p>

                    <p>
                      <strong>
                        Grupo:
                      </strong>
                      {" "}
                      {
                        planeacionSeleccionada.grupo
                      }
                    </p>

                    <p>
                      <strong>
                        Periodo:
                      </strong>
                      {" "}
                      {
                        planeacionSeleccionada.periodo
                      }
                    </p>

                    <p>
                      <strong>
                        Estado:
                      </strong>
                      {" "}
                      {
                        planeacionSeleccionada.estado
                      }
                    </p>

                  </div>

                </div>

                <div className="acciones-header">

                  <button
                    className="btn-agregar"
                    onClick={agregarUnidad}
                  >
                    + Unidad
                  </button>

                  <button
                    className="btn-pdf"
                    onClick={() =>
                      descargarPDF(
                        planeacionSeleccionada.id
                      )
                    }
                  >
                    Descargar PDF
                  </button>

                  {

                    planeacionSeleccionada.estado !==
                    "ENVIADA" && (

                      <button
                        className="btn-enviar"
                        onClick={
                          enviarPlaneacion
                        }
                      >
                        Enviar
                      </button>

                    )

                  }

                </div>

              </div>

              {

                unidades.map((u) => (

                  <div
                    key={u.id}
                    className="unidad-card"
                  >

                    <div className="unidad-top">

                      <h3>
                        {u.unidad}
                      </h3>

                      <button
                        className="btn-delete"
                        onClick={() =>
                          eliminarUnidad(u.id)
                        }
                      >
                        Eliminar
                      </button>

                    </div>

                    <div className="grid-unidad">

                      {
                        CAMPOS_UNIDAD.map(([campo, label]) => (

                          <textarea
                            key={campo}
                            placeholder={label}
                            value={
                              borradores[u.id]?.[campo] ?? ""
                            }
                            onChange={(e) =>
                              editarCampoBorrador(
                                u.id,
                                campo,
                                e.target.value
                              )
                            }
                          />

                        ))
                      }

                    </div>

                    <div className="unidad-footer">

                      <button
                        className="btn-guardar-unidad"
                        onClick={() =>
                          guardarUnidad(u.id)
                        }
                        disabled={
                          estadoGuardado[u.id] === "guardando"
                        }
                      >
                        {
                          estadoGuardado[u.id] === "guardando"
                            ? "Guardando..."
                            : "💾 Guardar"
                        }
                      </button>

                      {
                        estadoGuardado[u.id] === "ok" && (
                          <span className="guardado-ok">
                            ✅ Guardado
                          </span>
                        )
                      }

                      {
                        estadoGuardado[u.id] === "error" && (
                          <span className="guardado-error">
                            ❌ Error al guardar
                          </span>
                        )
                      }

                    </div>

                  </div>

                ))

              }

            </div>

          )

        }

      </div>

    </div>

  );

}